import { Component, Input, OnInit } from '@angular/core';
import { IconSeverityEnum } from './icon-severity.enum';
import { SeverityEnum } from '../../enums/severity.enum';

@Component({
    selector: 'app-helper',
    templateUrl: './helper.component.html',
    styleUrls: ['./helper.component.scss']
})
export class HelperComponent implements OnInit {
    @Input() public severity: SeverityEnum = SeverityEnum.SUCCESS;
    @Input() public icon: string = '';

    public ngOnInit(): void {
        if (!this.icon) {
            this.icon = this.getIconForSeverity(this.severity);
        }
    }

    private getIconForSeverity(severity: SeverityEnum): string {
        return IconSeverityEnum[severity] || '';
    }
}
